<div *ngIf="inventory" class="list_container">

    <div class="category-head ">
        <ion-text>{{inventory.product}}</ion-text>
        <ion-icon class="mouse" (click)="modalCtrl.dismiss()" name="close-outline"></ion-icon>
    </div>

   <div class="container__">
    <p class="m-0 p_name">{{inventory.name}}</p>
    <p class="m-0 p_product">{{inventory.product}}</p>
    <p class="m-0 p_rq"><span>Reserved Quantity : </span>{{inventory.reserved_qty}}</p>
    <p class="m-0 p_aq"><span>Actual Quantity : </span> {{inventory.actual_qty}}</p>
   </div>
</div>
